<template>
  <div class="content">
    <div class="content-img">
      <van-image :src="require('@/assets/img/newSuccess.png')"></van-image>
    </div>
    <div class="text-father" style="margin-bottom: 20px">
      <span>提交成功</span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  created() {
    // this.$httpAI({
    //   url: this.$httpAI.adornUrl('/problem/hasNew'),
    //   method: 'get'
    // }).then(({data}) => {
    //   if (data && data.code === 0) {
    //
    //   } else {
    //     this.$toast.fail(data.msg)
    //   }
    // })
  },
  methods: {

  }

}
</script>

<style scoped>
.content {
  height: 100vh !important;
  width: 100vw !important;
  background-color: white;
  padding-top: 120px;
  box-sizing: border-box;
}
.content-img {
  width: 300px;
  height: 300px;
  margin: 0 auto;
}
.x-close-dialog {
  font-size: 0.6rem;
  text-align: right;
  padding: 0.3rem 0.4rem 0 0
}
.text-father {
  font-size: 0.5rem;
  font-weight: bold;
  display: inline-block;
  width: 100%;
  text-align: center;
  span {
    color: #4581F8;
    font-size: 36px;
    font-weight: 500;
    font-family: PingFangSC, PingFang SC;
  }
}
</style>
